import React from "react";
import { createRoot } from "react-dom/client";

// Component
import App from "./App";
import OmniApp from "./whitelabel/omni/App";
import PublicisApp from "./whitelabel/publicis/App";
import CocaColaApp from "./whitelabel/cocacola/App";
import OmgMenaAmazonApp from "./whitelabel/omgmenaamazon/App";
import PvblicOneApp from "./whitelabel/pVblicOne/App";

// Store
import Store from "./store/store";

// Redux
import { Provider } from "react-redux";

const container = document.getElementById("root");
container.classList.add(process.env.REACT_APP_WHITELABEL)

const root = createRoot(container);

const getAppToDisplay = () => {
  console.log(process.env.REACT_APP_WHITELABEL);
  switch (process.env.REACT_APP_WHITELABEL) {
    case "cocacola": return <CocaColaApp />
    case "omni": return <OmniApp />
    case "publicis": return <PublicisApp />
    case "omgmenaamazon": return <OmgMenaAmazonApp />
    case "pVblicOne": return <PvblicOneApp />
  }
  return <App />
}
root.render(
  <Provider store={Store}>
    {getAppToDisplay()}
  </Provider>
);
